import { useIntl } from 'react-intl';
import { IconButton } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Expand arrow at the start of an assignment row, before its number (change
// request of 07.10). The row itself toggles too, so the click stops here.
const RowExpandToggle = ({
  open,
  onToggle,
}: {
  open: boolean;
  onToggle: () => void;
}) => {
  const intl = useIntl();
  return (
    <IconButton
      size="small"
      aria-expanded={open}
      aria-label={intl.formatMessage({
        id: open ? 'ORDERS.HIDE_DETAILS' : 'ORDERS.SHOW_DETAILS',
      })}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    </IconButton>
  );
};

export default RowExpandToggle;
